import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { FeeSummary } from "../types";

export interface FeeSummarySectionProps {
  feeSummary: FeeSummary;
}

const formatCurrency = (cents: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
};

export const FeeSummarySection: React.FC<FeeSummarySectionProps> = ({ feeSummary }) => {
  const { basePrice, vehicleCount, isPerVehicle, totalFee, renewalPeriodLabel } = feeSummary;

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          Fee Summary
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              Base fee ({renewalPeriodLabel})
            </Typography>
            <Typography variant="body2">{formatCurrency(basePrice)}</Typography>
          </Box>

          {isPerVehicle && (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2" color="text.secondary">
                Number of vehicles
              </Typography>
              <Typography variant="body2">x {vehicleCount}</Typography>
            </Box>
          )}

          <Divider />

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body1" fontWeight={600}>
              Total due
            </Typography>
            <Typography variant="body1" fontWeight={600} color="primary">
              {formatCurrency(totalFee)}
            </Typography>
          </Box>

          {isPerVehicle && vehicleCount > 1 && (
            <Typography variant="caption" color="text.secondary">
              {formatCurrency(basePrice)} per vehicle x {vehicleCount} vehicles
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default FeeSummarySection;
